import React from 'react';
import { includes, isEmpty } from 'lodash';
import Slider from 'react-slick';
import { graphql, useStaticQuery } from 'gatsby';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from './styles/Link.styled';
import {
  Container,
  InsightsSection,
  InsightsSlider as InsightsSliderStyled,
} from './styles/IndustryInsights.styled';
import InsightsCards from './InsightsCards';
import { SectionHeadline } from './styles/SectionHeadline.styled';
import { DWTCContext } from '../utils/context';
import Sprites from './Sprites';

export default function InsightsSlider({ data, dir, id }) {
  const { cssClass } = React.useContext(DWTCContext);

  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return 'red';
    if (includes(cssClass, 'real-estate')) return 'green';
    return 'secondary';
  };
  const query = useStaticQuery(graphql`
    query {
      umbraco {
        allInsight {
          items {
            id
            articleDate
            name
            subtitle
            title
            tags
            cardType
            imageOverlay
            url
            filters
            description
            relatedEventSectors
            featuredImage {
              url
            }
            level
            videoURL
          }
        }
      }
    }
  `);

  const { title, parentLink, currentId, itemsLimit = 7, relatedEventSectors, filterTags } = data;
  const [insights] = React.useState(query.umbraco.allInsight.items);
  const [filteredInsights, setFilteredInsights] = React.useState([]);

  React.useEffect(() => {
    let filtered = [...insights];
    if (filterTags && filterTags.length > 0) {
      filtered = filtered.filter(
        (insight) =>
          (insight.tags && insight.tags.indexOf(filterTags[0]) > -1) ||
          (insight.filters && insight.filters.indexOf(filterTags[0]) > -1),
      );
    }

    if (relatedEventSectors && relatedEventSectors.length > 0) {
      filtered = filtered.filter((insight) =>
        insight.relatedEventSectors.some(
          (sector) => sector === 'All' || relatedEventSectors.includes(sector),
        ),
      );
    }
    filtered = currentId ? filtered.filter((insight) => insight.id !== currentId) : filtered;

    filtered.sort((a, b) => new Date(b.articleDate) - new Date(a.articleDate));
    setFilteredInsights(itemsLimit ? filtered.slice(0, +itemsLimit) : filtered);
  }, []);

  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: filteredInsights.length > 3,
    autoplay: false,
    autoplaySpeed: 3500,
    dots: true,
    arrows: true,
    centerMode: false,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: insights.length > 2 ? 3 : insights.length,
          arrows: true,
          centerMode: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: insights.length > 1 ? 2 : insights.length,
          arrows: true,
          centerMode: false,
        },
      },
      {
        breakpoint: 819,
        settings: {
          arrows: false,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '150px',
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '65px',
        },
      },
      {
        breakpoint: 575,
        settings: {
          arrows: false,
          autoplay: false,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '60px',
        },
      },
      {
        breakpoint: 430,
        settings: {
          arrows: false,
          autoplay: false,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '22px',
        },
      },
    ],
  };

  return (
    filteredInsights &&
    filteredInsights.length > 0 && (
      <InsightsSection dir={dir} className={`insightshome_slider ${cssClass}`} id={id}>
        <Container className="zeropadding_responsive">
          <SectionHeadline className="section_caption insight-section-header" dir={dir}>
            <h2 dir={dir}>{title}</h2>
            {isEmpty(parentLink) || (
              <Link color={getTheme()} dir={dir} to={parentLink.url} className="home_link view_all">
                <p dir={dir}>{parentLink.name}</p>
                <Sprites name="arrow" className="arrow" />
              </Link>
            )}
          </SectionHeadline>
          <InsightsSliderStyled className="margin_slider_sv">
            <Slider {...settings}>
              {filteredInsights.map((item, index) => (
                <InsightsCards key={`InsightsCards_${index}`} dir={dir} isSlider data={item} />
              ))}
            </Slider>
          </InsightsSliderStyled>
        </Container>
      </InsightsSection>
    )
  );
}
